import {h} from 'preact'
import {PureComponent} from 'preact-compat'

import {FreshdeskHit} from '../algolia/components'
import FreshdeskResults from './FreshdeskResults'

interface Props {
  hits: Array<FreshdeskHit>
  pageCount: number,
  clickCallback: (hit: FreshdeskHit, idx: number) => void
}

interface State {
  hits: Array<FreshdeskHit>,
}

export default class extends PureComponent<Props, State> {
  constructor () {
    super()
    this.state = {
      hits: []
    }
  }

  updateList () {
    let joinWith: State['hits'] = []
    if (this.props.pageCount > 0) {
      joinWith = this.state.hits
    }

    this.setState({
      hits: joinWith.concat(this.props.hits)
    })
  }

  componentDidMount () {
    this.updateList()
  }

  componentDidUpdate (prevProps: Props) {
    if (JSON.stringify(this.props.hits) === JSON.stringify(prevProps.hits)) return

    this.updateList()
  }

  render ({ clickCallback} : Props) {
    return <div> {
      this.state.hits.map((hit, idx) => {
        return <FreshdeskResults clickCallback={() => clickCallback(hit, idx)} hit={hit} />
      })
    }</div>
  }
}

